import { clientEnvIsWindows } from "./isWindows";
import { clientEnvIsDesktop } from "./isDesktop";

export const clientEnvIsWindowsBrowser = (): boolean => {
  return clientEnvIsWindows() && !clientEnvIsDesktop();
};
